// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../common/JQueryView';
import DateRangePicker from '../../common/DateRangePicker';
export default class IndexView extends JQueryView {
  constructor() {
    super('.company.director_meetings.index');

    $('.showMore').on('click', e => {
      e.stopPropagation();
      $(e.target)
        .closest('.summary')
        .hide();
      $(e.target)
        .closest('td')
        .find('.details')
        .show();
    });

    $('.showLess').on('click', e => {
      e.stopPropagation();
      $(e.target)
        .closest('.details')
        .hide();
      $(e.target)
        .closest('td')
        .find('.summary')
        .show();
    });

    this.render();
  }

  initDateRangePicker(container: any) {
    new DateRangePicker(
      container,
      {
        singleDatePicker: true,
        timePicker: false,
        showDropdowns: true,
        locale: {
          format: 'Y/MM/DD',
          cancelLabel: 'Clear',
        },
      },
      {
        picker: {
          format: {
            start: 'Y/MM/DD',
            template: startDate => startDate,
          },
        },
      },
    ).render();
  }

  @on({
    event: 'click',
    selector: '#search-clear-btn',
  })
  onClearSearch() {
    $('#start_at_start_search').val('');
    $('#start_at_end_search').val('');
    $('#state_search').val('all');
    $('#input_search').val('');
  }

  render() {
    this.initDateRangePicker(this.$el);
  }

  @on({ event: 'click', selector: '.input-group-append' })
  onClickAppend(event: any) {
    $(event.target)
      .closest('.input-group')
      .find('.daterange-picker')
      .focus();
  }
}
